/** Por que a pergunta está sendo feita — define o título e o aviso do topo. */
export type MotivoSeedRegime =
    /** O cadastro da empresa não tem regime tributário. */
    | 'semRegime'
    /** O cadastro está em Regime Normal, mas sem o regime de apuração. */
    | 'semApuracao'
    /** O regime do cadastro foi recusado pelo seed (fora do catálogo ativo, por exemplo). */
    | 'regimeRecusado'
    /** Não foi possível ler ou interpretar o cadastro — a resposta NÃO será gravada nele. */
    | 'naoConsultado';

export class RegimeTributarioSeedDialogData {
    motivo: MotivoSeedRegime;
    /**
     * true quando a resposta será gravada em Configurações > Empresa. É false quando não
     * conseguimos ler o cadastro: aí a resposta serve só para este seed, e o rodapé não pode
     * prometer uma gravação que não vai acontecer.
     */
    gravarNoCadastro: boolean;
}
